import { Navigate, Route, Routes } from 'react-router';
import { Suspense, lazy, type ReactElement } from 'react';
import { Box, CircularProgress } from '@mui/material';
import { isAuthenticated } from './core/auth/useAuth';

const LoginPage = lazy(() => import('./features/auth/pages/LoginPage').then((m) => ({ default: m.LoginPage })));
const AdminLayout = lazy(() => import('./shared/components/AdminLayout').then((m) => ({ default: m.AdminLayout })));
const SocietiesPage = lazy(() => import('./features/societies/pages/SocietiesPage').then((m) => ({ default: m.SocietiesPage })));
const SocietyDetailPage = lazy(() => import('./features/societies/pages/SocietyDetailPage').then((m) => ({ default: m.SocietyDetailPage })));
const RateChartBuilderPage = lazy(() => import('./features/societies/pages/RateChartBuilderPage').then((m) => ({ default: m.RateChartBuilderPage })));
const UsersPage = lazy(() => import('./features/users/pages/UsersPage').then((m) => ({ default: m.UsersPage })));
const IncentiveReportsPage = lazy(() => import('./features/reports/pages/IncentiveReportsPage').then((m) => ({ default: m.IncentiveReportsPage })));
const ReportsPage = lazy(() => import('./features/reports/pages/ReportsPage').then((m) => ({ default: m.ReportsPage })));
const SettingsPage = lazy(() => import('./features/settings/pages/SettingsPage').then((m) => ({ default: m.SettingsPage })));

function RequireAuth({ children }: { children: ReactElement }) {
  return isAuthenticated() ? children : <Navigate to="/login" replace />;
}

function PageLoader() {
  return (
    <Box sx={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <CircularProgress />
    </Box>
  );
}

export function App() {
  return (
    <Suspense fallback={<PageLoader />}>
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route
          path="/"
          element={
            <RequireAuth>
              <AdminLayout />
            </RequireAuth>
          }
        >
          <Route index element={<Navigate to="/societies" replace />} />
          <Route path="societies" element={<SocietiesPage />} />
          <Route path="societies/:id" element={<SocietyDetailPage />} />
          <Route path="societies/:id/rate-charts" element={<RateChartBuilderPage />} />
          <Route path="users" element={<UsersPage />} />
          <Route path="reports" element={<ReportsPage />} />
          <Route path="reports/incentive" element={<IncentiveReportsPage />} />
          <Route path="settings" element={<SettingsPage />} />
        </Route>
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Suspense>
  );
}
